<!-- Card représentant une face dans le store -->

<div class="windowFaceList" (click)="openInfo(screenItem.i)" id="{{ faceItem.id }}">
    @if (faceItem.nf != null && faceItem.nf.length != 0) {
        <div class="nfReasonsContainer">
            <span
                >Indisponible du {{ faceItem.nf[0].di | date: 'dd/MM/yyyy' }} au
                {{ faceItem.nf[0].da | date: 'dd/MM/yyyy' }}</span
            >
            <span *ngIf="faceItem.nf[1] != null"
                >Indisponible du {{ faceItem.nf[1].di | date: 'dd/MM/yyyy' }} au
                {{ faceItem.nf[1].da | date: 'dd/MM/yyyy' }}</span
            >
            <span *ngIf="faceItem.nf.length > 2">Voir plus</span>
        </div>
    }

    @if (!screenItem.ic && (faceItem.nf == null || faceItem.nf.length <= 0)) {
        <div class="nfReasonsContainer">
            <span>Activité interdite</span>
        </div>
    }

    <!-- MARK: Tag sur La face -->
    @if (faceItem?.pd) {
        <div class="priceDiv" ngClass="{{ screenItem.sp === 14 ? 'indoor' : 'outdoor' }}">
            <span>Ecran {{ screenItem.sp === 14 ? 'intérieur' : 'exterieur' }}</span>
        </div>
    }


    <!-- MARK: Miniature de la face -->
    @if (faceItem.ts && faceItem.ts != null && faceItem.ts != '') {
        <img
            (click)="openImgDetail()"
            [ngClass]="[
                !screenItem.ic || (faceItem && faceItem.nf != null && faceItem.nf.length != 0)
                    ? 'screenImg inactiveScreen'
                    : 'screenImg',
            ]"
            alt="Miniature de l'écran"
            src="{{ baseUrl }}/file/getFile/{{ faceItem.ts }}/{{ faceItem.ts }}"
        />
    }

    <div
        [ngClass]="[
            !screenItem.ic || (faceItem && faceItem.nf != null && faceItem.nf.length != 0)
                ? 'screenTypeContainerDiv inactiveScreen'
                : 'screenTypeContainerDiv',
        ]"
    >
        <div class="screenTypeContainer">

            <!-- MARK: Distance et position de l'écran -->
            <div class="screenTypeInfo">
                <p class="screenTypeTxt">
                    @if (screenItem.sp === 14) {
                        <span class="indoor">Ecran Intérieur</span>
                    } @else {
                        <span class="outdoor">Ecran Géant bord de route</span>
                    }
                    <span class="distance"> à {{ screenItem.di }} Km </span>
                </p>
                <p class="locationInfo">
                    @if (faceItem.vs === 0) {
                        Vue Gauche
                    } @else if (faceItem.vs === 1) {
                        Vue Droite
                    }

                    @if (faceItem.dc != null) {
                        @if (faceItem.dc === 0) {
                            <span class="directionCity"> → Entrée de ville </span>
                        } @else if (faceItem.dc === 1) {
                            <span class="directionCity"> → Sortie de ville </span>
                        }
                    }
                </p>
            </div>
        </div>

        <!-- Adresse de l'écran -->
        <div class="locationContainer">
            <mat-icon class="material-icons-outlined" ngClass="{{ screenItem.sp === 14 ? 'indoor' : 'outdoor' }}">
                location_on
            </mat-icon>
            <p class="locationName">
                {{ screenItem.ad }}<br />
                {{ screenItem.zc }} {{ screenItem.cn }}
            </p>
        </div>

        <div class="actionContainer">
            <!-- Prix -->
            <p class="facePrice">
                {{ faceItem?.pd | currency: 'EUR' : 'symbol' : undefined : 'fr' }}<span class="perDay">/ jour</span>
            </p>

            <!-- Ajouter -->
            @if (
                !recapMode &&
                !displayRedirectStore &&
                (screenItem.ic || faceItem.selected) &&
                (faceItem.nf == null || faceItem.nf.length == 0 || faceItem.selected)
            ) {
                <article
                    matRipple
                    class="selectedDiv"
                    [ngClass]="{ selected: faceItem.selected }"
                    (click)="clickScreenFromMap(faceItem, screenItem)"
                >
                    @if (faceItem.selected) {
                        <span class="material-icons">check</span>
                        <span>Ajouté</span>
                    } @else {
                        <span>+ Ajouter</span>
                    }
                </article>
            }

            <!-- Bouton Select - Dans le recap Panier -->
            @if (recapMode) {
                <article class="selectedDiv" (click)="clickScreenFromMap(faceItem, screenItem)">
                    <span class="material-icons">delete</span>
                    <span>Retirer</span>
                </article>
            }

            <!-- Layer 'écran non disponible' -->
            @if ((!screenItem.ic || (faceItem.nf != null && faceItem.nf.length != 0)) && !faceItem.selected) {
                <div class="layerOn">
                    <span>Ecran non disponible</span>
                </div>
            }
        </div>

        <!-- MARK: Bouton fermer si mode mini -->
        @if (mini) {
            <button id="closeBtn" mat-stroked-button (click)="close()">Fermer</button>
        }

        @if (displayRedirectStore) {
            <button
                class="buyScreenBtn"
                (click)="clickScreenFromMap(faceItem, screenItem)"
                mat-flat-button
                color="primary"
            >
                Acheter cet écran
            </button>
        }
    </div>
</div>
